export default "__VITE_ASSET__CdX_HcYp__"